export const SupportedImageFileTypes = ['.jpeg', '.jpg', '.png'];
